document.addEventListener('DOMContentLoaded', function () {
    const slider = $('.js-types-slider');

    const initTypesSlider = () => {
      slider.slick({
          dots: false,
          arrows: false,
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true,
          rtl: m.about.rtl,
      });
    };

    slider && initTypesSlider();
});
